import { render, staticRenderFns } from "./queryScore.vue?vue&type=template&id=775cf510&scoped=true"
import script from "./queryScore.vue?vue&type=script&lang=js"
export * from "./queryScore.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "775cf510",
  null
  
)

export default component.exports